import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import type { VariableDef } from '../../lib/types';

/** One shared query for the library — palette, properties panel and dialogs all read it. */
export function useVariables() {
  return useQuery({ queryKey: ['variables'], queryFn: api.listVariables });
}

/** Choice groups (mutually-exclusive checkbox sets) — shared by dialogs and the groups section. */
export function useVariableGroups() {
  return useQuery({ queryKey: ['variable-groups'], queryFn: api.listVariableGroups });
}

/** Stable identity so selection memos don't rebuild on every loading render. */
export const NO_VARIABLES: VariableDef[] = [];

export const isPlaced = (v: VariableDef) => (v.usage?.placements ?? 0) > 0;

export const variableId = (v: VariableDef) => v.id;
